import { useTranslation } from "react-i18next";
import { quotationsSelector, addQuotationExtraThunk, deleteQuotationExtraThunk } from "../../features/quotationsSlice";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { ExtrasLoading } from "./ExtrasLoading";
import { Card } from "primereact/card";
import { CardHeader } from "./CardHeader";
import "./Extras.css";
import { ExtraCard } from "./ExtraCard";
import { Extra } from "../../types/quotations/Extra";
import { AddQuotationExtraRequestDto, DeleteQuotationExtraRequestDto } from "../../services/QuotationsServices";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { useParams } from "react-router-dom";
import { QuotationStatus } from "../../constants/QuotationConstants";

export const Extras = () => {
    const { quotationId } = useParams();
    const { user } = useAuthenticator((context) => [
        context.authStatus,
        context.user
    ]);
    const {SelectedQuotationExtrasStatus, SelectedQuotationExtras, SelectedQuotation} = useAppSelector(quotationsSelector);
    const { t } = useTranslation("locale");

    const dispatch = useAppDispatch();

    if (SelectedQuotationExtrasStatus !== "succeeded") {
        return <ExtrasLoading />;
    }

    if (SelectedQuotation?.status === QuotationStatus.LEAD) {
        return <></>;
    }

    const updateSelectedExtra = (extra: Extra) => {
        if (SelectedQuotationExtras.find((e) => e.extraServiceId === extra.extraServiceId)?.selectedByCustomer) {
            console.info("Deleting extra", extra);
            var deleteRequestData = {
                quotationId: quotationId,
                quotationExtraId: extra.quotationExtraId,
                user: user
            } as DeleteQuotationExtraRequestDto;
            dispatch(deleteQuotationExtraThunk(deleteRequestData));
        } else {
            console.info("Adding extra", extra);

            var addRequestData = {
                quotationId: quotationId,
                updatedExtraId: extra.extraServiceId,
                user: user
            } as AddQuotationExtraRequestDto;
            dispatch(addQuotationExtraThunk(addRequestData));
        }
    }

    const canEditExtras = SelectedQuotation?.status === QuotationStatus.OFFER || SelectedQuotation?.status === QuotationStatus.DRAFT;

    return (
        <Card header={CardHeader(t("quotations.extras.title"))}>
            <div
                id="quotation-order-extras"
                data-cy="quotation-order-extras"
            >
                <div>
                    <div className="light-text">{t("quotationExtras.description")}</div>
                </div>
                {SelectedQuotationExtras.map((extra) => (
                    <ExtraCard 
                        readonly={!canEditExtras}
                        key={`extra-${extra.extraServiceId}`}
                        extra={extra} 
                        onExtraSelected={updateSelectedExtra} />
                ))}
            </div>
        </Card>
    )
}